import {useDispatch} from 'react-redux';
import {useMemo} from 'react';
import {useQuery} from 'react-query';
import {fetchAllWidgets} from '../requests/queries/widgets';
import {fetchAuthWidgets} from '../requests/queries/easyAuth';

export const useWidgetFlows = () => {
  const dispatch = useDispatch();

  const {data, isLoading, isFetching} = useQuery(
    ['all-widgets', {limit: 10000, page: 1}],
    () => fetchAllWidgets({limit: 10000, page: 1}, dispatch),
  );

  const widgetFlows = useMemo(
    () =>
      (!isLoading &&
        data &&
        data?.widgets?.map(widget => ({
          value: widget._id,
          label: widget.name,
          name: widget.name,
        }))) ||
      [],
    [data, isLoading],
  );

  return {widgetFlows, isLoading: isLoading || isFetching};
};
export const useAuthWidgetFlows = () => {
  const {data, isLoading, isFetching} = useQuery(
    ['all-auth-widgets', {limit: 10000, page: 1}],
    () => fetchAuthWidgets({limit: 10000, page: 1}),
  );

  const authWidgetFlows = useMemo(
    () =>
      (!isLoading &&
        data &&
        data?.widgets?.map(widget => ({
          value: widget._id,
          label: widget.name,
          name: widget.name,
        }))) ||
      [],
    [data, isLoading],
  );

  const getWidgetNameById = id =>
    authWidgetFlows?.find(w => w.value === id)?.name;

  return {
    authWidgetFlows,
    isLoading: isLoading || isFetching,
    getWidgetNameById,
  };
};
